export default __webpack_public_path__ + "static/media/excellence.acb6429f.svg";